import React from 'react'

import PIPHandler from 'components/PIPHandler'
import ReconnectingNotification from 'components/ReconnectingNotification/ReconnectingNotification'
import Room from 'components/Room/Room'
import WebChatSocket from 'components/WebChatSocket'
import { roomConnectionStates } from 'constants/room'

const { RECONNECTING } = roomConnectionStates

const ClassRoom = props => {
    const { roomState } = props

    return (
        <>
            <WebChatSocket />
            <PIPHandler />
            <Room />
            <ReconnectingNotification open={roomState === RECONNECTING} />
        </>
    )
}

ClassRoom.propTypes = {}

export default ClassRoom
